import {Box} from '@mui/material';
import ArrModal from '../../../common/arr-modal/ArrModal';
import './CreateNewJob.scss';
import JobTypeSelector from './job-type-selector/JobTypeSelector';
import {t} from 'i18next';

interface CreateNewJobProps {
  handleJobTypeModalClose: () => void;
}

const CreateNewJob = ({handleJobTypeModalClose}: CreateNewJobProps) => {
  return (
    <>
      <Box className="create-job-blur-bg" />
      <ArrModal
        showModal={true}
        onClose={handleJobTypeModalClose}
        headerTitle=""
        showClose={false}
        ariaLabel={t('ai.review.jobType.title')}
        autoFocusCloseButton={true}
        className="job-type-modal"
        dataTestId="create-new-job-modal"
      >
        <Box className="job-type-selector-modal">
          <JobTypeSelector handleJobTypeModalClose={handleJobTypeModalClose} />
        </Box>
      </ArrModal>
    </>
  );
};

export default CreateNewJob;
